const getFieldIds = (filters, fieldIds) => {
    filters.forEach(node => {
        if (node && node.nodeType === 'Criterion' && node.fieldName !== undefined) {
            fieldIds.add(node.fieldName);
        }
        else if (node && node.nodeType === 'Filter') {
            getFieldIds(node.filters, fieldIds);
        }
    });
    return Array.from(fieldIds);
};
export const getFieldIdsFromFilters = (filters) => {
    return getFieldIds(filters, new Set());
};
